import apiCrud from '../../abstract/api-crud';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/crms/system-balances`;
export const modelName = 'systembalance';

export default {
  ...apiCrud({ baseUri, modelName }),
  indexCurrent: async ({ id }) => await axios.post(`${ baseUri }/current`),
};
